export enum FileType {
  JPG = 'JPG',
  JPEG = 'JPEG',
  PNG = 'PNG',
  PDF = 'PDF',
  UNKNOWN = 'UNKNOWN',
  IMAGE = 'IMAGE',
}

export function checkFileTypeByFileName(fileName: string): FileType {
  const fileExtension = getUrlExtension(fileName).toLowerCase()
  if (fileExtension === FileType.PDF.toLowerCase()) {
    return FileType.PDF
  }
  if (fileExtension === FileType.JPG.toLowerCase()) {
    return FileType.IMAGE
  }
  if (fileExtension === FileType.JPEG.toLowerCase()) {
    return FileType.IMAGE
  }
  if (fileExtension === FileType.PNG.toLowerCase()) {
    return FileType.IMAGE
  }
  return FileType.UNKNOWN
}

export const isFileTypeImage = (fileName: string): boolean => {
  return checkFileTypeByFileName(fileName) === FileType.IMAGE
}

const patternFileExtension = /\.([0-9a-zA-Z]+)(?:[?#]|$)/i

const getUrlExtension = (url: string): string => {
  const fileExtension = url.match(patternFileExtension)

  return fileExtension?.[1] || ''
}
